const rebuyRemoveItem = async (smartCart, item) => {
  return new Promise((resolve, _reject) => {
    smartCart.removeItem(item, (e) => {
      resolve();
    });
  });
};

document.addEventListener(
  "rebuy:smartcart.line-item-removed",
  async (event) => {
    const smartcart = event.detail.smartcart;
    const item = event.detail.item;
    const properties = item.properties;

    if (!properties || properties.bundle !== "BYOB") return;

    const bundleId = properties._bundle_id;

    for (let i = 0; i < smartcart.cart.items.length; i++) {
      const lineItem = smartcart.cart.items[i];
      if (item.key == lineItem.key) continue;
      if (lineItem.properties?._bundle_id !== bundleId) continue;
      await rebuyRemoveItem(smartcart, lineItem);
    }
  }
);

document.addEventListener('DOMContentLoaded', function () {
  const elements = document.querySelectorAll('[id*="faq_9pNfwf"]');

  elements.forEach(function (element) {
    element.classList.add('edu-blog-faq');
  });

  const videoWidgets = document.querySelectorAll('[id*="_widgets_H7geWG"]');

  videoWidgets.forEach(function (element) {
    element.parentNode.parentNode.classList.add('edu-blog-video');
  });
});

/** Berry Breeze Landing Page Announcement Bar */
document.addEventListener('DOMContentLoaded', function () {
  if (document.body.classList.contains('paid-lander-berrybreez')) {
    const announcementSlider = document.getElementById('AnnouncementSlider');

    if (announcementSlider) {
      announcementSlider.innerHTML = '<span class="static-announcement">Fast & Free Shipping on EVERY Order</span>';
    }
  }
});

/** PDP Shadow Root Styling + Moving Elements */
document.addEventListener('DOMContentLoaded', function () {
  if (document.body.className.includes('product')) {
    let intervalCounter = 0;
    const maxIntervalChecks = 10;
    const interval = 1000;

    const checkInterval = setInterval(function () {
      const aftershipContainer = document.querySelector('.aftership-container');

      if (aftershipContainer) {
        const sheet = new CSSStyleSheet
        sheet.replaceSync(`.as-widget-wrapper { background: #FFFFFF !important; border: none !important; } .as-widget-template div, .as-widget-destination-line span {color: #44382A !important;}`)
        document.querySelector('.aftership-container').shadowRoot.adoptedStyleSheets.push(sheet)

        const widgetTemplate = aftershipContainer.shadowRoot.querySelector('.as-widget-template');
        const widgetDescription = aftershipContainer.shadowRoot.querySelector('.as-widget-destination-line span');
        if (widgetTemplate) {
          widgetTemplate.style.color = '#44382A';
        }
        if (widgetDescription) {
          widgetDescription.style.color = '#44382A';
        }
        clearInterval(checkInterval);
      }
      intervalCounter++;

      if (intervalCounter >= maxIntervalChecks) {
        clearInterval(checkInterval);
      }
    }, interval);

    // Function to wrap elements
    function wrapSalesPoints() {
      
      if (window.innerWidth >= 1200) {
        const productSections = document.querySelectorAll('.product-section');

        productSections.forEach(section => {
          const salesPoints = section.querySelectorAll('.product-block--sales-point');
          if (salesPoints.length > 0) {
            // Create a new div element that will act as the container
            const container = document.createElement('div');
            container.className = 'sales-points-container';

            // Insert the container into the DOM before the first sales point
            salesPoints[0].parentNode.insertBefore(container, salesPoints[0]);

            // Move each sales point into the container
            salesPoints.forEach(function (point) {
              container.appendChild(point);
            });
          }
        }
        );
      }
    }

    // Initially wrap sales points on page load
    wrapSalesPoints();
  }
});

function preventTouchpadNavigation(classSelector) {
  const noNavigationElement = document.querySelector(classSelector);

  // Prevent browser navigation gestures
  const preventNavigation = (event) => {
    if (event.deltaX !== 0) { // Horizontal scroll is likely a navigation gesture
      event.preventDefault();
    }
  };

  // Add listener on hover
  noNavigationElement?.addEventListener('mouseenter', () => {
    noNavigationElement.addEventListener('wheel', preventNavigation, { passive: false });
  });

  // Remove listener when not hovering
  noNavigationElement?.addEventListener('mouseleave', () => {
    noNavigationElement.removeEventListener('wheel', preventNavigation);
  });
}

const updateQuantityByBaseQuantity = (cart) => {
  const rebuyCart = document.querySelector("#rebuy-cart");
  if (!rebuyCart) return;

  const items = cart.items();

  for (let i = 0; i < items.length; i++) {
    const lineItem = items[i];

    if (lineItem.properties && !!lineItem.properties['_base-quantity-step']) {
      const baseQuantity = parseInt(lineItem.properties['_base-quantity-step']);
      if (baseQuantity == NaN) continue;

      const baseQuantityStep = lineItem.quantity * baseQuantity;
      const handle = lineItem.handle ? lineItem.handle : lineItem.product.handle;

      const lineItemContainer = rebuyCart.querySelectorAll(`li`)[i];
      if (!lineItemContainer.classList.contains(`product-${handle}`)) continue;

      const quantityWidgetLabel = lineItemContainer.querySelector(`.rebuy-cart__flyout-item-quantity-widget-label`);
      if (!quantityWidgetLabel) continue;
      quantityWidgetLabel.innerHTML = baseQuantityStep;
    }
  }
}


const shopifyAddToCart = (variantId, qty) => {
  const add = {
    'items': [{
      'id': variantId,
      'quantity': qty
    }]
  }

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(add)
  })
    .then(response => {
      return response.json();
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}

const shopifyChangeQuantity = (lineItem, qty) => {
  const change = {
    'id': lineItem.key,
    'quantity': qty
  }

  fetch(window.Shopify.routes.root + 'cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(change)
  })
    .then(response => {
      return response.json();
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}

const overwriteRebuyAddToCart = () => {
  if (!window.Rebuy) return;
  const items = window.Rebuy.Cart.items();
  const rebuyCart = document.querySelector("#rebuy-cart");
  if (!rebuyCart) return;

  const hasBaseBundleItem = items.some(item => {
    return item.properties && item.properties['_base-quantity-step'] !== "";
  });

  if (!hasBaseBundleItem) return;

  if (!window.increaseItem) {
    window.increaseItem = window.Rebuy.SmartCart.increaseItem;
  }
  if (!window.decreaseItem) {
    window.decreaseItem = window.Rebuy.SmartCart.decreaseItem;
  }

  window.Rebuy.SmartCart.increaseItem = function (lineItem) {
    const baseQuantity = parseInt(lineItem.properties['_base-quantity-step']);
    const qtyIncrement = parseInt(lineItem.properties['_base-quantity-increment']);

    if (!baseQuantity) {
      window.increaseItem(lineItem);
    } else {
      const totalQuantity = lineItem.quantity + qtyIncrement;
      shopifyChangeQuantity(lineItem, totalQuantity)
    }
  }

  // Block customers from purchasing below base quantity
  window.Rebuy.SmartCart.decreaseItem = function (lineItem) {
    const baseQuantity = parseInt(lineItem.properties['_base-quantity-step']);
    const minimumQuantity = qtyIncrement = parseInt(lineItem.properties['_base-quantity-increment']);

    if (!!baseQuantity && baseQuantity != NaN && lineItem.quantity <= minimumQuantity) {
      shopifyChangeQuantity(lineItem, 0);
    }
    else if (!!baseQuantity && baseQuantity != NaN) {
      const newQuantity = lineItem.quantity - qtyIncrement;
      shopifyChangeQuantity(lineItem, newQuantity);
    } else {
      window.decreaseItem(lineItem);
    }
  }
}

window.shipping_protection = {
  title: "Shipping Protection",
  variantId: 43899415593140,
}

function rebuyShippingProtection() {
  if (!window.Rebuy) return;
  const rebuyCart = document.querySelector("#rebuy-cart");
  if (!rebuyCart) return;

  const shippingProtectionInput = rebuyCart.querySelector('#shipping-protection-input');

  const shippingItemIsPresent = window.Rebuy.Cart.cart.items.some(item => {
    return item.title === window.shipping_protection.title;
  });

  if (!shippingProtectionInput) return;
  if (shippingProtectionInput.checked) {
    // Add shipping protection
    if (shippingItemIsPresent) return;

    shopifyAddToCart(window.shipping_protection.variantId, 1);
  }
  else {
    if (!shippingItemIsPresent) return;
    // Remove shipping protection
    const shippingProtectionItem = window.Rebuy.Cart.cart.items.find(item => item.title === window.shipping_protection.title);
    if (!shippingProtectionItem) return;
    window.Rebuy.SmartCart.removeItem(shippingProtectionItem, (e) => {
      console.log(e);
    });
  }
}

const syncShippingProtectionInput = () => {
  const rebuyCart = document.querySelector("#rebuy-cart");
  if (!rebuyCart) return;

  const shippingProtectionInput = rebuyCart.querySelector('#shipping-protection-input');
  if (!shippingProtectionInput) return;

  const cartLength = window.Rebuy.Cart.cart.items.length;
  const shippingProtectionContainer = rebuyCart.querySelector('#rebuy-shipping-protection-widget');
  if (shippingProtectionContainer) {
    if (cartLength > 0) {
      // shippingProtectionContainer.style.display = 'block';
      shippingProtectionContainer.classList.remove('offset');
    }
    else {
      shippingProtectionContainer.classList.add('offset');
      // shippingProtectionContainer.style.display = 'none';
    }
  }

  const shippingItemIsPresent = window.Rebuy.Cart.cart.items.some(item => {
    return item.title === window.shipping_protection.title;
  });

  shippingProtectionInput.checked = shippingItemIsPresent;
}

document.addEventListener('rebuy:smartcart.show', async (event) => {
  overwriteRebuyAddToCart();
  syncShippingProtectionInput();
  updateQuantityByBaseQuantity(event.detail.smartcart);
});

document.addEventListener('rebuy:smartcart.ready', (event) => {
  overwriteRebuyAddToCart();
  syncShippingProtectionInput();
  updateQuantityByBaseQuantity(event.detail.smartcart);
});

document.addEventListener('rebuy:cart.change', (event) => {
  overwriteRebuyAddToCart();
  syncShippingProtectionInput();
  updateQuantityByBaseQuantity(event.detail.cart);
});

/* FAQs - Remove class on buttons */
document.addEventListener('DOMContentLoaded', () => {
  if (!document.body.classList.contains('faq')) return;
  const buttons = document.querySelectorAll('.text-columns .btn.btn--secondary.btn--small');
  buttons.forEach(btn => btn.classList.remove('btn--secondary'));
});
